import { gql } from '@apollo/client';
/**
 * @const RefuseDealMutation
 * @since 1.0.0
 */
export const RefuseDealMutation = gql `
  mutation RefuseDealMutation($input: RefuseDealInput!) {
    refuseDeal(input: $input)
  }
`;
